export interface InsuranceValidatorCarouselProduct {
  id: string
  title: string
  imageUrl: string
}

export type InsuranceValidatorCarouselProductResponse =
  InsuranceValidatorCarouselProduct[]
